export const checkIsAbandonedCart = () => {
  const tealiumInfo = JSON.parse(localStorage.getItem('tealium_va')) || {}
  const isAbandonedCart = tealiumInfo.badges && tealiumInfo.badges['5023']
  return isAbandonedCart
}

